<template>
  <b-row no-gutters>
    <b-modal
      id="modal-make-speaker"
      ref="modalSpeakerKey"
      :hide-header="true"
      :hide-footer="true"
      :cancel-disabled="true"
      content-class="blah"
      dialog-class="moderatorWrapper"
      body-class="moderatorBody"
    >
      <b-row
        no-gutters
        class="mod-title"
      >
        <moderator-key-icon
          :size="24"
          fill-color="#4A4A4A"
          class="icon"/>
        <span class="mod-text">
          {{ $t('MEETING.WAITING_ENTER_SPEAKERPIN') }}
        </span>
      </b-row>
      <b-form-input
        v-model="speakerKey"
        :placeholder="$t('MEETING.WAITING_SPEAKERPIN')"
        class="form-control-light mod-input"/>
      <b-row
        no-gutters
        class="mod-btns"
      >
        <b-btn
          size="sm"
          variant="secondary-light"
          @click="cancelSpeakerKey">
          {{ $t('MEETING.CANCEL') }}
        </b-btn>
        <b-btn
          size="sm"
          variant="primary-light"
          style="margin-left:16px"
          @click="submitSpeakerKey">
          {{ $t('MEETING.SUBMIT') }}
        </b-btn>
      </b-row>
    </b-modal>
  </b-row>
</template>

<script>
import {ref} from "@vue/composition-api"
import ModeratorKeyIcon from "../icons/ModeratorKey"
export default {
  name: 'MakeModerator',
  components: {
    ModeratorKeyIcon,
  },
  setup(props, context) {
    const speakerKey = ref("")

    function cancelSpeakerKey() {
      context.refs.modalSpeakerKey.hide()
    }

    function submitSpeakerKey() {
      context.parent.handCommand(true, speakerKey.value, "")
      speakerKey.value = ""
      context.refs.modalSpeakerKey.hide()
    }
    
    return {
      speakerKey,
      submitSpeakerKey,
      cancelSpeakerKey
    }
  }
}
</script>
<style>
.moderatorWrapper {
  max-width: 420px;
  padding: 0;
}
.moderatorBody {
  min-height: 116px;
  background-color: #ffffff;
  padding: 16px;
  border-radius: .25rem !important;
}
.mod-title {
  width: 348px;
  margin: 16px;
}
.mod-text {
  color: #282828;
  font-weight: 600;
  line-height: 24px;
  font-size: 16px;
  margin-left: 8px;
}
.mod-input {
  width: 340px;
  height: 48px;
  margin-left: 46px;
}
.mod-btns {
  margin-top: 34px;
  display: flex;
  justify-content: flex-end;
}
</style>


// WEBPACK FOOTER //
// src/components/MakeSpeaker.vue